import { render, staticRenderFns } from "./ResultsRouterPage.vue?vue&type=template&id=d429685c"
import script from "./ResultsRouterPage.vue?vue&type=script&lang=js"
export * from "./ResultsRouterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports